<script setup>

import ComparePowerCard from "components/ComparePowerCard.vue";

const wide_url = `${ process.env.ASSETS_URL }images/lemonade/lemonade-conf-renters-wide.svg`
const narrow_url = `${ process.env.ASSETS_URL }images/lemonade/lemonade-conf-renters-narrow.svg`
const click = () => {
  window.open('https://my.comparepower.com/lemonade-orders-conf', '_blank')
}
</script>

<template>
  <compare-power-card class="cursor-pointer" @click="click">
    <q-img class="gt-xs" :src="wide_url" width="100%" fit="contain"></q-img>
    <q-img class="lt-sm" :src="narrow_url" width="100%" fit="contain"></q-img>
  </compare-power-card>
</template>

<style scoped>

</style>
